export default __webpack_public_path__ + "static/bed-bath-beyond-7-d-fad814384a3316cba29a8ea774a447b1.gif";